module.exports = __webpack_public_path__ + "img/znch.a3f116e.png";